import React from 'react';
import { PERSON_SPECIALITIES, COMPANY_SPECIALITIES } from '../../../utils/ConstantsMain';
import './CategorySelector.scss';

const CategorySelector = ({
    handleSelectorCategory,
}) => {

    return (
        <div className='CategorySelector'>
            <p className='CategorySelector_title'>Categorías generales</p>
            <div className='CategorySelector_container'>
                <p className='CategorySelector_container-title'>Particulares</p>
                <div className='CategorySelector_container-containerButtons'>
                    {PERSON_SPECIALITIES && PERSON_SPECIALITIES.map((elem, index) => {
                        return (
                            <h2
                                key={index}
                                onClick={() => handleSelectorCategory(elem)}
                                className='CategorySelector_container-buttons'
                            >
                                {elem}
                            </h2>
                        )
                    })}
                </div>
            </div>
            <div className='CategorySelector_container'>
                <p className='CategorySelector_container-title'>Empresas</p>
                <div className='CategorySelector_container-containerButtons'>
                    {COMPANY_SPECIALITIES && COMPANY_SPECIALITIES.map((elem, index) => {
                        return (
                            <h2
                                key={index}
                                onClick={() => handleSelectorCategory(elem)}
                                className='CategorySelector_container-buttons'
                            >
                                {elem}
                            </h2>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default CategorySelector;
